// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_addedToWaitlist = (i) => `But you've been added to the waitlist and will be contacted when a spot becomes available.`